import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import MixinsCom from './mixins';

var PayAccountAddOrEditPage = function (_super) {
  __extends(PayAccountAddOrEditPage, _super);

  function PayAccountAddOrEditPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.provinceList = [];
    return _this;
  }

  Object.defineProperty(PayAccountAddOrEditPage.prototype, "isShowCaAddress", {
    get: function get() {
      return this.isNeedPayeeCaAddress(this.formData);
    },
    enumerable: false,
    configurable: true
  });

  PayAccountAddOrEditPage.prototype.getRegionList = function () {
    var _a;

    return __awaiter(this, void 0, Promise, function () {
      var countryCode, params, res;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            countryCode = (_a = this.formData.payee_info) === null || _a === void 0 ? void 0 : _a.country_code;

            if (this.$util.isEmpty(countryCode)) {
              return [2];
            }

            params = {
              country_code: countryCode
            };
            return [4, this.$api.certification.getRegionList(params)];

          case 1:
            res = _b.sent();
            this.provinceList = res.data || [];
            return [2];
        }
      });
    });
  };

  PayAccountAddOrEditPage.prototype.handleCountryChange = function () {
    this.provinceList = [];
    this.formData.payee_info.province_code = undefined;
    this.getRegionList();
  };

  __decorate([Prop({
    type: Object,
    "default": {}
  })], PayAccountAddOrEditPage.prototype, "formData", void 0);

  __decorate([Prop({
    type: Array,
    "default": {}
  })], PayAccountAddOrEditPage.prototype, "registerCountryList", void 0);

  PayAccountAddOrEditPage = __decorate([Component({
    components: {}
  })], PayAccountAddOrEditPage);
  return PayAccountAddOrEditPage;
}(Mixins(MixinsCom));

export default PayAccountAddOrEditPage;